<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      element-loading-text="加载中..."
    >
      <zj-layout-header>
        <div class="listtitle">游客画像</div>
        <el-form
          class="zj-search-form"
          ref="queryForm"
          :model="queryParams"
          :label-width="labelWidth"
        >
          <el-form-item label="时间" prop="timeRange">
              <el-date-picker
                v-model="queryParams.timeRange"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                :clearable="false">
              </el-date-picker>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="ecahrts-wrap">
          <div class="ecahrts-left">
            <div>
               <!-- <BarEchartTicket
                title="游客来源（省）"
                xAxisName=""
                yAxisName=""
                :chartData="usePerData1"
              ></BarEchartTicket> -->
               <barchart2
                title="游客来源（省）"
                xAxisName=""
                yAxisName=""
                className="echarts-01"
                :chartData="provinceTop10"
              ></barchart2>
            </div>
            <div>
               <barchart2
                title="游客来源（市）"
                xAxisName=""
                yAxisName=""
                className="echarts-02"
                :chartData="cityTop10"
              ></barchart2>
            </div>
          </div>
          <div class="echart-middle">
            <ChinaMapEchart :chartData="proveiceData">

            </ChinaMapEchart>
          </div>
          <div class="echart-right">
            <div>
              <LineEchart2Ticket
                title="客流走势与同比"
                xAxisName=""
                yAxisName=""
                :chartData="compareData"
                :legendData="legendData"
              ></LineEchart2Ticket>
            </div>
            <div>
              <PieEchartsTicket
                title="游客性别分布"
                xAxisName=""
                yAxisName=""
                :chartData="sexData"
              ></PieEchartsTicket>
            </div>
            <div>
              <barchart2
                title="游客年龄分布"
                xAxisName=""
                yAxisName=""
                :chartData="ageData"
              ></barchart2>
            </div>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
import { getSourceProvinceByTimeValue, getSourceCityByTimeValue, getTrendByTimes, getAgeByTimes2, getSexByTimes2 } from "@/api/src/bigData";

import ZJApp from '../../../../app';
const utils = ZJApp.ZJUtils;

import moment from 'moment';
export default {
  name: "TouristPortrait",
  controller: "UI",
  action: "TouristPortrait",
  components: {
  },
  data() {
    return {
      // 遮罩层
      loading: false,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      queryParams:{
        timeRange:null,
      },
      compareData:{
        days:[],
        data:[],
        dataLast:[],
      },
      legendData:[],
      provinceTop10:{
        days:[],
        data:[],
      },
      cityTop10:{
        days:[],
        data:[],
      },
      ageData:{
        days:[],
        data:[],
      },
      sexData:[
        {name:'男',value:0},
        {name:'女',value:0}
      ],
      proveiceData:[],
    };
  },
  created: function() {
    this.$nextTick(()=>{
      this.onCancel()
    });
  },
  methods: {
   // 点击清理按钮
    onCancel() {
      this.queryParams.timeRange = [moment().format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')]
      this.onSearch();
    },
    async onSearch(){
      this.loading = true
      this.init()
      let { queryParams:{timeRange:[startTime, endTime]}, provinceTop10, cityTop10 } = this, that = this;
      var params = this.getAreaTimeSearchParams(this.config.area.type, this.config.area.code, startTime, endTime);

      let beforeStartTime = moment(startTime).subtract(1, 'year').format('YYYY-MM-DD');
      let beforeEndTime = moment(endTime).subtract(1, 'year').format('YYYY-MM-DD');

      let year = this.getTimeRangLegend(beforeStartTime, beforeEndTime)
      let year2 = this.getTimeRangLegend(startTime, endTime)
      var params2 = this.getAreaTimeSearchParams(this.config.area.type, this.config.area.code, beforeStartTime, beforeStartTime);
      this.legendData = [year,year2]
      utils.waitAll([
        getSourceProvinceByTimeValue("staPassengerAnalysis", params), 
        getSourceCityByTimeValue("staPassengerAnalysis", params), 
        getTrendByTimes("staPassengerAnalysis", params),
        getTrendByTimes("staPassengerAnalysis", params2),
        getAgeByTimes2("staPassengerAnalysis", params),
        getSexByTimes2("staPassengerAnalysis", params)
      ])
      .then(res => {
        that.loading = false;
        
        that.proveiceData = res[0].data || []
        
        res[0].data&&res[0].data.forEach((item, index) => {
          if(index < 10){
            provinceTop10.days.push(item.name)
            provinceTop10.data.push(item.count)
          }
        })
        res[1].data&&res[1].data.forEach((item, index) => {
          if(index < 10){
            cityTop10.days.push(item.name)
            cityTop10.data.push(item.count)
          }
        })
       this.provinceTop10 = provinceTop10
       this.cityTop10 = cityTop10

        that.$set(that.compareData,'days',this.resetData(res[2].data,'dataTime', params.timeType))
        that.$set(that.compareData,'dataLast',this.resetData(res[2].data,'count'))
        that.$set(that.compareData,'data',this.resetData(res[3].data,'count'))
        that.$set(that.ageData,'days',this.resetData(res[4].data,'name'))
        that.$set(that.ageData,'data',this.resetData(res[4].data,'value'))
        that.sexData = res[5].data.splice(0,2)
      }).catch((res =>{
        this.loading = false;
      }))
    },
    init(){
      this.compareData={
        days:[],
        data:[],
        dataLast:[],
      }
      this.legendData = []
      this.provinceTop10 = {
        days:[],
        data:[],
      }
      this.cityTop10 = {
        days:[],
        data:[],
      }
      this.ageData = {
        days:[],
        data:[],
      }
      this.sexData = [
        {name:'男',value:0},
        {name:'女',value:0}
      ]
      this.proveiceData = []
    },
    resetData(data,key,type){
      let arr = []
      data.forEach(item => {
        let value = item[key]
        if(type){
          value = this.getTimeByType(type, value)
        }
        arr.push(value)
      })
      return arr
    }
  },
};
</script>
<style scoped lang="scss">
.ecahrts-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom:2.8rem;
}
.ecahrts-left{
  width: 25%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  div{
    width: 100%;
    height: 48%;
  }
}
.echart-middle{
  width:48%;
  height: 100%;
}
.echart-right {
  width: 25%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  div{
    width: 100%;
    height: 33%;
  }
}
.echart-down{
  margin-top: 15px;
}
</style>
